<template>
    <div>
        <div class="main-cnt block-image">
            <div class="block-cnt-img">
                <img src="@/assets/img/voucher-img.png">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SpImageVoucher',
    data () {
        return {
        };
    },
    computed: {
    },
    created () {
    },
    methods: {
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/Image.vue